import Tooltip from "@/tooltip";
import { ExclamationTriangleIcon } from "@/icons/solid";
import BuddySelector from "@/components/common/custom-selectors/BuddySelector";
import { useEffect } from "react";
import { connect } from "react-redux";
import AsyncSelect from "react-select/async";
import { Actions as INTEGRATION_ACTIONS } from "../../../store/actions/integrationActions";
import { Actions as WORKFORCE_ACTIONS } from "./store/workforceActions";

const WorkforceEmployeeLink = ({
	agreementInfo,
	thirdPartyList,
	getWorkforceEmployees,
	getWorkforceTeams,
	setEmployeeTeams,
	thirdPartyId,
	disabled,
	switchEmployeeLink,
	selectedTeams,
	teams,
}) => {
	const thirdPartyEmployee = thirdPartyList?.find?.((e) => e?.value == thirdPartyId);

	useEffect(() => {
		if (!thirdPartyList?.length) {
			getWorkforceEmployees();
			getWorkforceTeams();
		}
	}, []);

	return (
		<div className={`col-xs-${thirdPartyEmployee ? 9 : 3} pl-0 pr-0`}>
			<div className={`col-xs-${thirdPartyEmployee ? 4 : 12}`}>
				<div className="form-material form-container">
					<label htmlFor="material-text">
						<Tooltip content="The employee reference code is used when importing punches or timesheets, hence it needs to be synchronised with third party software. If you do not link with third party software you are free to use this code for internal reference purposes.">
							Workforce Link
						</Tooltip>
					</label>
					<BuddySelector
						isDisabled={disabled}
						name="thirdPartyLink"
						options={thirdPartyList}
						value={thirdPartyEmployee}
						onChange={(selected) => {
							switchEmployeeLink(selected.value);
						}}
					/>
				</div>
			</div>
			{thirdPartyEmployee ? (
				<div className="col-xs-8">
					<div className="form-material form-container">
						<label htmlFor="material-text">
							<Tooltip
								content={
									<div style={{ whiteSpace: "nowrap" }}>
										<p style={{ color: "white", fontWeight: 700, marginBottom: 0 }}>
											<strong>Only</strong> import timesheets and leave assigned to these
											locations.
										</p>
										<p style={{ color: "white", fontWeight: 700 }}>
											<ExclamationTriangleIcon
												className="h-7 w-7"
												style={{ verticalAlign: "middle", marginRight: "0.5rem" }}
											/>
											Any timesheets or leave assigned to other locations{" "}
											<strong>will not be imported</strong>.
										</p>
									</div>
								}
							>
								Workforce Teams
							</Tooltip>
						</label>
						<AsyncSelect
							isDisabled={disabled || teams?.length == 0}
							name="thirdPartyLink"
							noOptionsMessage={() => "No teams available for this employee"}
							defaultOptions={teams}
							isMulti
							placeholder={teams?.length == 0 ? "No teams available" : "Select if applicable"}
							isLoading={!teams}
							value={selectedTeams}
							onChange={(selected) => {
								setEmployeeTeams({ teams: selected, agreement: agreementInfo.id });
							}}
						/>
					</div>
				</div>
			) : null}
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const agreementInfo = ownProps.agreementInfo ? ownProps.agreementInfo : state.employee.agreementInfo;

	const thirdPartyList = state.integration.timeAttendance?.tanda?.employees?.map?.((e) => ({
		label: e.name,
		value: e.id,
	}));
	const thirdPartyLink = state?.integration.timeAttendance?.tanda?.links?.find?.(
		(e) => e?.agreement == agreementInfo?.id,
	);
	const thirdPartyId = state.employee?.tandaLink || thirdPartyLink?.link;
	const thirdPartyEmployee = state?.integration.timeAttendance?.tanda?.employees?.find?.(
		(e) => e?.id == thirdPartyId,
	);

	const selectedTeams = thirdPartyLink?.teams ?? [];

	// const fullList = _.orderBy(employeeListWithSalary?.map(employee => ({
	//   value: employee.id,
	//   label: `${employee.employeeName} ${employee.employeeSurname}`,
	//   terminated: employee.isTerminated
	// })) || [], ['label', 'terminated'], ['asc', 'asc'])
	//
	// const terminated = fullList.filter(e => e.terminated)
	// const active = fullList.filter(e => !e.terminated)
	//
	// const employeeOptions = [ {
	//   label: "Active",
	//   options: active,
	// }, {
	//   label: "Terminated",
	//   options: terminated,
	// }]

	const teams = state?.integration.timeAttendance?.tanda?.locations
		?.map((l) => {
			return {
				label: l.name,
				options: state?.integration.timeAttendance?.tanda?.teams
					// filter teams available for the selected employee
					?.filter((t) => t.locationId == l.id && thirdPartyEmployee?.teams.includes(parseInt(t.id)))
					?.map((t) => ({
						label: t.name,
						value: t.id,
					})),
			};
		})
		// only show locations with teams available for the selected employee
		?.filter((l) => l.options?.length > 0);

	return {
		agreementInfo,
		thirdPartyList,
		thirdPartyId,
		selectedTeams,
		teams,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getWorkforceEmployees: () => dispatch(WORKFORCE_ACTIONS.getWorkforceEmployees()),
	getWorkforceTeams: () => dispatch(WORKFORCE_ACTIONS.getWorkforceTeams()),
	setEmployeeTeams: ({ agreement, teams }) => dispatch(WORKFORCE_ACTIONS.setEmployeeTeams({ agreement, teams })),
	switchEmployeeLink: (employee) => dispatch(INTEGRATION_ACTIONS.switchEmployeeLink(employee, "tanda")),
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkforceEmployeeLink);
